import {useCallback,useEffect,useRef,useState} from 'react';
import {api,apiError} from '../lib/api';

// poll=false loads once (and again when the assignment changes) without a timer:
// lists poll only the item the user is working on.
export default function useDriverDispatch(assignment,enabled,{poll=true}={}) {
  const id=assignment?.id,version=`${assignment?.updated_at||''}:${assignment?.driver_dispatch?.revision??''}`;
  const [result,setResult]=useState(null),[error,setError]=useState(''),[loading,setLoading]=useState(false);
  const generation=useRef(0),alive=useRef(false);
  const invalidate=useCallback(()=>{alive.current=false;generation.current++;},[]);
  const reload=useCallback(async()=>{
    if(!enabled||!id)return null;
    const current=++generation.current;setLoading(true);setError('');
    try{const {data}=await api.get(`/assignments/${id}/dispatch`);if(alive.current&&current===generation.current)setResult({id,version,data});return data;}
    catch(e){if(alive.current&&current===generation.current){setResult(null);setError(apiError(e));}return null;}
    finally{if(alive.current&&current===generation.current)setLoading(false);}
  },[enabled,id,version]);
  useEffect(()=>{
    alive.current=true;setResult(null);setError('');void reload();
    const refresh=()=>{if(document.visibilityState!=='hidden')void reload();};
    const watch=enabled&&id&&poll;
    const timer=watch?setInterval(refresh,20000):null;
    if(watch)window.addEventListener('focus',refresh);
    return()=>{invalidate();clearInterval(timer);window.removeEventListener('focus',refresh);};
  },[enabled,id,poll,reload,invalidate]);
  return {data:result&&result.id===id&&result.version===version?result.data:null,error,loading,reload};
}
